<template>
  <v-main style="width: 360px">
    <v-row class="pt-1">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
        {{ $t("map.panel.vehicle.tachograph.day_drive") }}
      </v-col>
      <v-col cols="7">
        <v-progress-linear
          :value="calcProgressValue(vehicle.ride.driver.tachograph.dayDriveAccumulation, vehicle.ride.driver.tachograph.dayDriveLimit)"
          height="18"
          rounded
          color="orange"
          style="width: 200px; display: inline-block">
          <span class="white--text"> {{ formatTachographDuration(vehicle.ride.driver.tachograph.dayDriveAccumulation) }}
              <span class="grey--text text--lighten-1">&nbsp;•&nbsp;{{ $t("common.remaining") }}&nbsp;</span>
              {{ formatTachographDuration(vehicle.ride.driver.tachograph.dayDriveLimit
              - vehicle.ride.driver.tachograph.dayDriveAccumulation) }}</span>
        </v-progress-linear>
      </v-col>
    </v-row>

    <v-row style="margin-top: -20px">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
        {{ $t("map.panel.vehicle.tachograph.day_rest") }}
      </v-col>
      <v-col cols="7">
        {{ formatUtcTimeDuration(vehicle.ride.driver.tachograph.lastDayRestTime, vehicle.ride.driver.tachograph.lastDayRestDuration)
        }}
      </v-col>
    </v-row>

    <v-row style="margin-top: -20px">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
      </v-col>
      <v-col cols="7">
        {{ formatUtcTimeDuration(vehicle.ride.driver.tachograph.lastDayRestTime, vehicle.ride.driver.tachograph.lastDayRestDuration, false)
        }}
        <span class="grey--text">&nbsp;•&nbsp;</span>
        <span
          class="blue--text text--lighten-4">{{ formatTachographDuration(vehicle.ride.driver.tachograph.lastDayRestDuration)
          }}</span>
      </v-col>
    </v-row>

    <v-row style="margin-top: -20px">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
        {{ $t("map.panel.vehicle.tachograph.week_drive") }}
      </v-col>
      <v-col cols="7">
        <v-progress-linear
          :value="calcProgressValue(vehicle.ride.driver.tachograph.dayDriveAccumulation, vehicle.ride.driver.tachograph.dayDriveLimit)"
          height="18"
          rounded
          color="blue"
          style="width: 200px; display: inline-block">
          <span class="white--text">{{ formatTachographDuration(vehicle.ride.driver.tachograph.weekDriveAccumulation) }}
                  <span class="grey--text text--lighten-1">&nbsp;•&nbsp;{{ $t("common.remaining") }}&nbsp;</span>
                  {{ formatTachographDuration(vehicle.ride.driver.tachograph.weekDriveLimit
              - vehicle.ride.driver.tachograph.weekDriveAccumulation) }}</span>
        </v-progress-linear>
      </v-col>
    </v-row>

    <v-row style="margin-top: -20px">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
        {{ $t("map.panel.vehicle.tachograph.week_rest") }}
      </v-col>
      <v-col cols="7">
        {{ formatUtcTimeDuration(vehicle.ride.driver.tachograph.lastWeekRestTime, vehicle.ride.driver.tachograph.lastWeekRestDuration)
        }}
      </v-col>
    </v-row>

    <v-row style="margin-top: -20px">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
      </v-col>
      <v-col cols="7">
        {{ formatUtcTimeDuration(vehicle.ride.driver.tachograph.lastWeekRestTime, vehicle.ride.driver.tachograph.lastWeekRestDuration, false)
        }}
        <span class="grey--text">&nbsp;•&nbsp;</span>
        <span
          class="blue--text text--lighten-4">{{ formatTachographDuration(vehicle.ride.driver.tachograph.lastWeekRestDuration)
          }}</span>
      </v-col>
    </v-row>

    <v-row style="margin-top: -20px">
      <v-col cols="5" class="grey--text text--lighten-2 body-2 text-right px-2 text_row_title">
        {{ $t("map.panel.vehicle.tachograph.twoweeks_drive") }}
      </v-col>
      <v-col cols="7">
        {{ formatTachographDuration((vehicle.ride.driver.tachograph.previousWeekDriveAccumulation || 0) + (vehicle.ride.driver.tachograph.weekDriveAccumulation || 0))
        }}
      </v-col>
    </v-row>

  </v-main>
</template>

<script>

import utils from "@/utils";
import { DateTime } from "luxon";

export default {
  name: "TachographTooltip",

  props: {
    vehicle: {
      type: Object,
      mandatory: true
    }
  },

  data() {
    return {
    };
  },

  methods: {
    calcProgressValue(value, maxValue) {
      return value / (maxValue / 100);
    },

    formatTachographDuration(value) {
      if (value >= 0)
        return utils.formatHours(value);
      else
        return utils.formatHours(0);
    },

    formatUtcTimeDuration(time, duration, from = true) {
      if (time !== null) {
        if (from) {
          return DateTime.fromISO(time, { zone: 'UTC'}).subtract({ minutes: duration }).toISO().toLocaleString(DateTime.DATETIME_SHORT);
        } else {
          return DateTime.fromISO(time, { zone: 'UTC'}).toISO().toLocaleString(DateTime.DATETIME_SHORT);
        }
      } else
        return null;
    }
  }
};

</script>
